<template>
  <div v-if="isVisible">
    <div :class="{ noSidebar: !isVisibleSidebar }" class="notificationWrapper">
      <span class="notification">
        <v-icon class="yellow--text text--darken-1">warning</v-icon>
        <span class="description">{{ description }}</span>
      </span>
      <v-btn
        v-if="hasAdminPermissionForAdvertiser"
        @click="activateAdvertiser()"
        :loading="loading"
        class="activateButton"
        dark
        color="yellow darken-3"
      >
        有効化する
      </v-btn>
    </div>
    <div style="height: 45px"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RouteHelper from '@/mixins/RouteHelper'
import AdvertiserRepository from '@/models/Advertiser/AdvertiserRepository'
import { mapActions } from 'vuex'

export default {
  name: 'ContentNotification',
  mixins: [RouteHelper],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters('currentAdvertiser', ['currentAdvertiser']),
    ...mapGetters('drawer', {
      isVisibleSidebar: 'showFlag',
    }),
    hasAdminPermissionForAdvertiser() {
      if (!this.currentAdvertiser) return true
      if (this.currentAdvertiser.hasAdminPermission) return true
      return false
    },
    isVisible() {
      // 広告主ページ
      if (!this.isAdvertiserPage) return false
      if (!!this.currentAdvertiser && !this.currentAdvertiser.isActive)
        return true
      return false
    },
    description() {
      if (this.hasAdminPermissionForAdvertiser) {
        return '広告主のステータスが「無効」になっています。広告配信をする場合、広告主を有効化してください。'
      } else {
        return (
          '広告主のステータスが「無効」になっています。\n' +
          '広告配信をする場合、広告主のステータスを「有効」に切り替えるよう代理店・システム管理者に依頼して下さい'
        )
      }
    },
  },
  methods: {
    ...mapActions('currentAdvertiser', {
      getCurrentAdvertiser: 'GET',
    }),
    ...mapActions('snackbar', {
      showSnackbarSuccess: 'SHOW_SNACKBAR_SUCCESS',
    }),
    async activateAdvertiser() {
      this.loading = true
      try {
        const advertiserId = this.currentAdvertiser.id
        await AdvertiserRepository.changeStatus(advertiserId, 'active')
        await this.getCurrentAdvertiser({ advertiserId })
        this.showSnackbarSuccess('広告主のステータスを有効にしました。')
      } catch (e) {
        throw new Error('ステータスの変更に失敗しました。')
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.notificationWrapper {
  position: fixed;
  right: 0;
  left: 0;
  margin-left: 220px;
  height: 48px;
  z-index: 2;
  /** background-color: #ff5252; **/
  background-color: #fffee4;
  display: flex;
  flex-direction: row;
}
.noSidebar {
  margin-left: 0px;
}

.notification {
  padding-left: 20px;
  padding-top: 14px;
  flex: 1;
  /** 二行以上にしない */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activateButton {
  width: 100px;
}
.description {
  padding-left: 10px;
  vertical-align: text-bottom;
}
</style>
